export default function FormFooter({
  activeTab,
  setActiveTab,
  formData,
  setExperiences,
  setFormData,
  experiences,
  showAddForm,
  setShowAddForm,
  handleSubmitWorkHistory,
  handleSubmitPassport,
  handleSubmitTravel, // <- added
  passportData,
  travelHistoryList, // <- added
  setPassportError,
  editingPassport,
  allWorkDeleted,
  setViewMode,
}) {
  const handleNext = () => {
    if (activeTab === "work") {
      if (formData.hasWorked === "no") {
        setActiveTab("passport");
        return;
      }
      if (experiences.length > 0) {
        setActiveTab("passport");
        return;
      }
      return;
    }

    if (activeTab === "passport") {
      // NO PASSPORT CASE
      if (formData.hasPassport === "no") {
        if (!formData.tentativeDate) {
          setPassportError("Please select tentative date to proceed forward");
          return; //  stop navigation
        }

        setPassportError("");
        setActiveTab("travel");
        return;
      }

      // YES PASSPORT CASE
      if (passportData && passportData.length > 0) {
        setPassportError("");
        setActiveTab("travel");
      }
    }

    if (activeTab === "travel") {
      // allow next if travel saved OR user selected "no"
      if (
        formData.hasTravelled === "no" ||
        (travelHistoryList && travelHistoryList.length > 0)
      ) {
        // proceed to whatever next (you had only 3 tabs; if there are more, change)
        // For now, keep current behaviour: do nothing or close modal
      }
      return;
    }
  };

  // -------------------------------
  // SAVE EXPERIENCE
  // -------------------------------
  const handleSaveExperience = () => {
    if (
      !formData.organization ||
      !formData.workingFrom ||
      !formData.jobIndustry ||
      !formData.jobRole ||
      !formData.jobType ||
      !formData.income
    ) {
      alert("Please fill all required fields before saving.");
      return;
    }

    setExperiences((prev) => [...prev, formData]);
    handleSubmitWorkHistory();

    setFormData((prev) => ({
      ...prev,
      organization: "",
      workingFrom: "",
      workingTill: "",
      currentlyWorking: false,
      jobIndustry: "",
      jobRole: "",
      jobType: "",
      income: "",
    }));

    setShowAddForm(false);
  };

  // -------------------------------
  // SAVE PASSPORT
  // -------------------------------
  const handleSavePassport = () => {
    handleSubmitPassport(); // API call
  };

  // -------------------------------
  // SAVE TRAVEL
  // -------------------------------
  const handleSaveTravel = async () => {
    handleSubmitTravel();
    setViewMode("review");
  };

  const handlePrevious = () => {
    if (activeTab === "travel") setActiveTab("passport");
    else if (activeTab === "passport") setActiveTab("work");
  };

  return (
    <div className="border-t border-gray-200 px-8 py-6 flex items-center justify-between bg-gray-50">
      {/* LEFT SIDE (placeholder keeps right buttons aligned) */}
      <div>
        {activeTab !== "work" && (
          <button
            onClick={handlePrevious}
            className="px-6 py-2 text-[#572575] font-bold bg-gray-200 text-sm rounded-lg"
          >
            Previous
          </button>
        )}
      </div>

      {/* RIGHT SIDE */}
      <div className="flex items-center gap-2">
        {/* WORK SAVE */}
        {activeTab === "work" &&
          !allWorkDeleted &&
          (experiences.length === 0 || showAddForm) && (
            <button
              onClick={handleSaveExperience}
              className="px-6 py-2 bg-[#572575] text-sm text-white rounded-lg"
            >
              Save
            </button>
          )}

        {/* PASSPORT UPDATE */}
        {activeTab === "passport" &&
          (passportData.length === 0 || editingPassport) && (
            <button
              onClick={handleSavePassport}
              className="px-6 py-2 bg-[#572575] text-sm text-white rounded-lg"
            >
              Update
            </button>
          )}

        {/* TRAVEL */}
        {activeTab === "travel" && (
          <button
            onClick={handleSaveTravel}
            className="px-6 py-2 bg-[#572575] text-sm text-white rounded-lg"
          >
            Review & Submit
          </button>
        )}

        {/* NEXT */}
        {((activeTab === "work" && experiences.length > 0) ||
          (activeTab === "passport" && passportData.length > 0) ||
          (activeTab === "travel" &&
            (formData.hasTravelled === "no" ||
              travelHistoryList?.length > 0))) && (
          <button
            onClick={handleNext}
            className="px-6 py-2 bg-[#572575] text-sm text-white rounded-lg"
          >
            Next
          </button>
        )}
      </div>
    </div>
  );
}
